import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoryUploadDetailComponent } from '../../Core/Shared/HistoryUpload/HistoryUploadDetail.component';

@Component({
  selector: 'WPHistoryUploadDetail',
  templateUrl: './WPHistoryUploadDetail.component.html'
})
export class WPHistoryUploadDetailComponent {
}
